<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="student_club_id" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('club_name')">
                            <student-club-selectbox :validateError="errors[0]"
                                                    v-model="form.student_club_id"
                                                    :state="errors[0] ? false : null">
                            </student-club-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="role" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('role')">
                            <parameter-selectbox v-model="form.role"
                                                 :validate-error="errors[0]" code="student_club_roles"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="academic_year" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox v-model="form.academic_year"
                                                 :validate-error="errors[0]"></academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="membership_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('member_at')">
                            <select-date v-model="form.membership_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('student')">
                        <ValidationProvider name="user_id" rules="required" v-slot="{ errors }">
                            <b-form-input
                                v-model="presidentValue.text"
                                :disabled="true"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox v-model="form.status"
                                                 :validate-error="errors[0]" code="student_club_student_statuses"></parameter-selectbox>                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="mobile_tel" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('mobile_number')">
                            <b-form-input
                                :placeholder="$t('mobile_placeholder')"
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-model="form.mobile_tel" disabled></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="email" rules="required|email" v-slot="{valid, errors}">
                        <b-form-group :label="$t('email')">
                            <b-form-input
                                :placeholder="$t('email_placeholder')"
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-model="form.email" disabled></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button
                    @click="updateForm"
                    type="button"
                    :disabled="formLoading"
                    variant="primary"
                    class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
    import StudentsAutoCompleteByKey from "@/components/interactive-fields/StudentsAutoCompleteByKey"
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import StudentClubMemberSearch from "@/services/StudentClubMemberSearch";
    import StudentClubSelectbox from "@/components/interactive-fields/StudentClubSelectbox.vue";


    export default {
        components: {
            StudentsAutoCompleteByKey,
            StudentClubSelectbox,
            ValidationProvider, ValidationObserver,
            ParameterSelectbox,
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                selectedPresident: '',
                presidentValue: {},
                form: {
                    student_club_id: null,
                    role: [],
                    academic_year: [],
                    member_at: null,
                    user_id: null,
                    status: '',
                    mobile_tel: null,
                    email: '',
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        created() {
            this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                StudentClubMemberSearch.get(id)
                               .then((response) => {
                                   this.form = response.data.data;
                                   if (this.form.user_id) {
                                       const fullName = `${this.form.user.name} ${this.form.user.surname}`;
                                       this.selectedPresident = fullName;
                                       this.presidentValue = {
                                           value: this.form.user_id,
                                           text: fullName
                                       };
                                       this.form.mobile_tel = this.form.user?.mobile_tel
                                       this.form.email = this.form.user?.email
                                   }
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;
                    StudentClubMemberSearch.update(this.formId, this.form)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            },
            handleSelection(user) {
                this.form.user_id = user?.user_id;
                this.selectedPresident = user ? `${user.name} ${user.surname}` : '';
            }
        }
    }
</script>
